import React from "react";

const NoDataAvailable = ({ aspectRatio = "5by2", additionalInfo }) => {
  return (
    <div
      className={`aspect-ratio aspect-ratio-${aspectRatio} bg-white`}
      style={{
        // border: ".5rem solid #f7f7f7",
        borderRadius: "1rem",
        boxShadow: "inset 0 0 2rem .25rem rgba(0,0,0,0.05)",
      }}
    >
      <div className="aspect-ratio-content">
        <div
          className="p-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
          style={{ color: "#d6d6d6" }}
        >
          <i
            className="fa fa-warning text-center fa-5x w-25 h-25"
            style={{ color: "#f7f7f7" }}
          />
          <p className="mb-0 font-weight-bold">
            Oh no, theres something wrong here!
          </p>
          {additionalInfo ? (
            additionalInfo
          ) : (
            <p className="mb-0">
              Please{" "}
              <a style={{ color: "#d6d6d6" }} href="/contact">
                contact us
              </a>{" "}
              to get this fixed!
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoDataAvailable;



// WEBPACK FOOTER //
// ./resources/assets/js/app/NoDataAvailable/NoDataAvailable.js